import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import StepZilla from 'react-stepzilla'
import { resetForgotPassword } from '@severed-links/common.redherrings-reducers/forgotPassword'
import { checkEmail } from '@severed-links/common.redherrings-reducers/siteRegistration'

import '../SiteRegistration/ProgressTracker.scss'
import * as s from './ForgotPassword.scss'

import ForgotPasswordStep1 from './ForgotPasswordStep1'
import ForgotPasswordStep2 from './ForgotPasswordStep2'
import ForgotPasswordEnterCode from './ForgotPasswordEnterCode'
import ForgotPasswordEnterNew from './ForgotPasswordEnterNew'
import ForgotPasswordConfirmation from './ForgotPasswordConfirmation'
import PublicAccountShell from '../Public/components/PublicAccountShell'

const ForgotPassword = () => {

    const dispatch = useDispatch()
    const fp = useSelector(state => state.forgotPassword)

    useEffect(() => { dispatch(resetForgotPassword()) }, [])

    const steps = [
        { name: 'Send Method', component: <ForgotPasswordStep1 /> },
        { name: fp.sendBy || 'Number', component: <ForgotPasswordStep2 /> },
        { name: 'Enter Code', component: <ForgotPasswordEnterCode /> },
        { name: 'Enter Password', component: <ForgotPasswordEnterNew />},
        { name: 'Confirmation', component: <ForgotPasswordConfirmation />}
    ]
    return (
        <PublicAccountShell
            eyebrow='Account recovery'
            title='Reset it securely.'
            description='Verify your account, enter your code, and choose a fresh password.'
            icon='lock'
            footer={<span>Remembered your password? <Link to='/login'>Return to login</Link></span>}>
                <div className={s.flowHeading}>
                    <h2>Reset your password</h2>
                    <p>We’ll verify it’s you before making any changes.</p>
                </div>
                <div className={s.forgotPasswordContainer}>
                    <div className='step-progress'>
                        <StepZilla
                            steps={steps}
                            startAtStep={0}
                            showSteps
                            showNavigation
                            stepsNavigation
                            prevBtnOnLastStep
                            preventEnterSubmission={false}
                            nextTextOnFinalActionStep={'Reset'}
                            // backButtonText={<span><FontAwesomeIcon name='chevron-left' /> Back</span>}
                            backButtonText={'Back'}
                            backButtonCls={`btn btn-prev btn-light btn-lg`}
                            // nextButtonText={<span>Next <FontAwesomeIcon name='chevron-right' /></span>}
                            nextButtonText={'Next'}
                            nextButtonCls={`btn btn-next btn-light btn-lg${(fp.nextDisabled ? ' ' + s.nextDisabled : ``)}`}
                        />
                    </div>
                </div>
        </PublicAccountShell>
    )
}

export default ForgotPassword
